module.exports = __webpack_public_path__ + "static/media/thumbnail-apple-watch-series-5_2x.4c00b856.png";